import React from 'react';

const Tabs = (props) => {
    const { tabs, current, handleTabChange } = props;
    return (
      <div className="cms-multi-tab-main">
        <div className="cms-multi-tab-link ">
          {tabs?.map((tb, key) => {
            return (
              <button
                key={key}
                className={`btn text-sm cms-tab-link-item no-focus py-2 px-0 ${
                  current === tb ? "active" : ""
                }`}
                onClick={() => handleTabChange(tb)}
              >
                {tb}{" "}
              </button>
            );
          })}
        </div>
      </div>
    );
  };
  
  export default Tabs;